export const STORAGE_KEYS = {
  RECENT_IMPERSONATIONS: "recent_impersonations",
  SKIPPED_ONBOARDING_PREFIX: "skippedOnboarding_",
  // Campaign Workflow States
  COACH_NEW_CAMPAIGN_STEP: "coachNewCampaignStep",
  COACH_CAMPAIGN: "coachCampaign",
  COACH_EDIT_CAMPAIGN: "coachEditCampaign",
  COACH_EDIT_CAMPAIGN_TAB: "coachEditCampaignTab",
  // Video Tasks
  HAS_VIDEO_PAGE_TASKS: "hasVideoPageTasks",
};

/**
 * Sweeps and purges all user-session related keys from localStorage and sessionStorage.
 *
 * @param playerId The current player ID to scope session-specific keys
 * @param isExplicitLogout True if this is an explicit account logout, clearing impersonation and workflow histories
 */
export const clearUserStorage = (playerId?: number, isExplicitLogout = false) => {
  if (typeof window === "undefined") return;

  try {
    // 1. Clear session-scoped keys
    if (playerId) {
      sessionStorage.removeItem(`${STORAGE_KEYS.SKIPPED_ONBOARDING_PREFIX}${playerId}`);
      localStorage.removeItem(`${STORAGE_KEYS.SKIPPED_ONBOARDING_PREFIX}${playerId}`);
    }

    // 2. Clear global user-session keys only on explicit account logout
    if (isExplicitLogout) {
      // Impersonation History
      localStorage.removeItem(STORAGE_KEYS.RECENT_IMPERSONATIONS);

      // Workflow States & Campaign Drafts
      localStorage.removeItem(STORAGE_KEYS.COACH_NEW_CAMPAIGN_STEP);
      localStorage.removeItem(STORAGE_KEYS.COACH_CAMPAIGN);
      localStorage.removeItem(STORAGE_KEYS.COACH_EDIT_CAMPAIGN);
      localStorage.removeItem(STORAGE_KEYS.COACH_EDIT_CAMPAIGN_TAB);

      // Video Tasks
      localStorage.removeItem(STORAGE_KEYS.HAS_VIDEO_PAGE_TASKS);
    }
  } catch (e) {
    console.warn("Failed to clear user storage:", e);
  }
};
